import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

function RouteWithTitle({ children }) {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    const currentPath = location.pathname;

    switch (currentPath) {
      case '/service':
        setPageTitle('سرویس ها - صفحه شخصی امیر حسین سیفی');
        break;
      case '/about':
        setPageTitle('درباره من - صفحه شخصی امیر حسین سیفی');
        break;
      case '/project':
        setPageTitle('پروژه ها - صفحه شخصی امیر حسین سیفی');
        break;
      case '/contact':
        setPageTitle('تماس با من - صفحه شخصی امیر حسین سیفی');
        break;
      case '/login':
        setPageTitle('ورود - صفحه شخصی امیر حسین سیفی');
        break;
      case '/admin':
        setPageTitle('داشبورد - صفحه شخصی امیر حسین سیفی');
        break;
      case '/admin/create/service':
        setPageTitle('ایجاد سرویس - صفحه شخصی امیر حسین سیفی');
        break;
      case '/admin/create/project':
        setPageTitle('ایجاد پروژه - صفحه شخصی امیر حسین سیفی');
        break;
      case '/admin/create/about':
        setPageTitle('ایجاد مهارت - صفحه شخصی امیر حسین سیفی');
        break;
      case '/admin/message':
        setPageTitle('پیام ها - صفحه شخصی امیر حسین سیفی');
        break;
      default:
        setPageTitle('صفحه شخصی امیر حسین سیفی - برنامه نویس و طراح وب');
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      {children}
    </>
  );
}

export default RouteWithTitle;